import { msSinceLastWake } from '@officehub/offline-sdk';
import { tabVisibility, type TabVisibility } from './tabVisibility';

/**
 * Why was this call cold? (smart-knock, 2026-10-29.) Every miss measured so far had to be reconstructed from Cloud Run request logs after the
 * fact. These two facts ride along on the report itself: whether the tab was in front or hidden when the call failed or was slow, and how long
 * ago this browser last knocked for that callable (null = never, or unreadable). Names and numbers only; nothing from the request.
 */
export interface WakeContext {
  readonly visibility: TabVisibility;
  readonly msSinceLastKnock: number | null;
}

export function wakeContextFor(callable: string): WakeContext {
  let ms: number | null = null;
  try {
    ms = msSinceLastWake(callable);
  } catch {
    ms = null;
  }
  return { visibility: tabVisibility(), msSinceLastKnock: ms === null ? null : Math.round(ms) };
}
